import React, { Fragment, useContext } from "react";
import { Typography, makeStyles } from "@material-ui/core";
import { useTranslate } from "react-admin";
import { LongTextField, WorkflowContext } from "ra-friendsofbabba";
import useTimePermission from "../useTimePermission";
import classNames from "classnames";

const useStyles = makeStyles((theme) => ({
  caption: {
    display: "block",
    clear: "both",
  },
  state: {
    fontWeight: "bold",
  },
}));
const FilenameField = ({ lastSent, disabled, ...props }) => {
  const hasTimePermission = useTimePermission();
  const hasPermission = hasTimePermission(props.record);
  const translate = useTranslate();
  const classes = useStyles();
  const { getWorkflow } = useContext(WorkflowContext);
  const workflow = getWorkflow("projects");
  const state =
    props?.record?.transaction?.state !== "draft"
      ? workflow.getStateByCode(props?.record?.transaction?.state)
      : null;

  return (
    <Fragment>
      <LongTextField {...props} minWidth={400} maxRows={3} variant="body2" />
      {!hasPermission && !disabled && (
        <Typography variant="caption" className={classes.caption}>
          {translate("ra.messages.not_editable")}
        </Typography>
      )}

      {state && (
        <Typography
          variant="caption"
          className={classNames(classes.caption, classes.state)}
        >
          {state?.name}
        </Typography>
      )}
    </Fragment>
  );
};
export default FilenameField;
